import { Dispatch } from 'redux'
import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { coalesceThunk } from 'app/state/utils/coalesce-thunk'
import { ErrorNotification } from 'app/views/components/notifications/notification'
import { getPositionsScreen, startLoadingPositionsScreen, stopLoadingPositionsScreen } from './actions'

/**
 * The whole Positions grid in one request: every my-company lender's
 * position on an approved facility, every name resolved, the amounts and the
 * past-due flag computed. The backend scans the positions once, narrow, and
 * matches six small lookups — so the page no longer downloads every position
 * in the tenant with its whole history and joins thirteen lists per row.
 *
 * Coalesced: a strict-mode double mount joins the request in flight. On
 * failure the store keeps what it had, the user is told, the loader stops.
 */
export const loadPositionsScreen = coalesceThunk(() => async (dispatch: Dispatch) => {
  const apiServerUrl = config.backendUrl
  try {
    dispatch(startLoadingPositionsScreen())
    const response = await client.get(`${apiServerUrl}/api/positions/screen`)
    return dispatch(getPositionsScreen(response.data))
  } catch (e: any) {
    ErrorNotification({
      title: 'Could not load positions',
      message:
        e?.response?.data?.error ?? 'The Positions grid could not be loaded. Reload the page to try again.',
    })
  } finally {
    dispatch(stopLoadingPositionsScreen())
  }
})
